import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BuildingControlProjectsType } from "../../Types/BuildingControl/BuildingControlProjectsType";
import { fetchAllBuildingControlProjects } from "../../Thunks/BuildingControlThunks";

interface BuildingControlSlice {
    loadingBuildingControlProjects: boolean;
    buildingControlProjects: BuildingControlProjectsType[];
    errorBuildingControlProjects: string | null;
}

// set initial values
const initialState: BuildingControlSlice = {
    loadingBuildingControlProjects: false,
    buildingControlProjects: [],
    errorBuildingControlProjects: null,
};

// set state value for api response
const buildingControlSlice = createSlice({
    name: "buildingControl",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllBuildingControlProjects.pending, (state) => {
                state.loadingBuildingControlProjects = true;
                state.errorBuildingControlProjects = null;
            })
            .addCase(fetchAllBuildingControlProjects.fulfilled, (state, action: PayloadAction<BuildingControlProjectsType[]>) => {
                state.loadingBuildingControlProjects = false;
                state.buildingControlProjects = action.payload;
            })
            .addCase(fetchAllBuildingControlProjects.rejected, (state, action) => {
                state.loadingBuildingControlProjects = false;
                state.errorBuildingControlProjects = action.error.message ?? "Failed to fetch building control projects";
            });
    },
});

export default buildingControlSlice.reducer;
